import React, { Component } from 'react';
import {storyTemplates, checkUploadType,uploadPreview, profilePicValidityCheck} from '../../utils/constants' 
import { Row, Col, Label, Button, CardTitle, CardText, Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import Toggle from "react-toggle";
import axios from '../../axios';
import * as url from '../../utils/url';
import classnames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../modules/actions/index';
import ReactPlayer from 'react-player/lazy'
import Checkbox from 'rc-checkbox';
import { takeRightWhile } from 'lodash';
import './InviteUsers.css';
import {groupRoles,eventRoles} from '../../utils/constants';



class InviteUsers extends Component {

	constructor(props) {
    super(props);
			this.state = { 
                setImagesPreview:[],
				invitedUsers:[],
				users:[],
				removeUsers:this.props.item.inviteUsers&&this.props.item.invitedUsers.length>0?
						this.props.item.invitedUsers.map(e=>e.value).concat(this.props.user._id): 
						this.props.inviteUsers&&this.props.invitedUsers.length>0?
						this.props.invitedUsers.map(e=>e.value).concat(this.props.user._id): 
						[].concat(this.props.user._id),
                searchImg:'',
				privacy: true,
				isBannerOpen:false,
				item:this.props.item,
				collaborators:'',
		  }
          this.timer=null
    }

	componentDidMount(){
		this.setState({
			removeUsers:this.props.item.inviteUsers&&this.props.item.invitedUsers.length>0?
						this.props.item.invitedUsers.map(e=>e.value).concat(this.props.user._id): 
						this.props.inviteUsers&&this.props.invitedUsers.length>0?
						this.props.invitedUsers.map(e=>e.value).concat(this.props.user._id): 
						[].concat(this.props.user._id),
		})
	}

	componentDidUpdate(prevProps,prevState){ 
		let{invitedUsers}=this.props
		if(prevProps.invitedUsers.length!=invitedUsers.length){
			
			let result = invitedUsers.map(e=>{
				return e.value
			})

			this.setState(prevState=>({
				removeUsers: [...result, ...prevState.removeUsers]
			}))
		}
	}

	assignedUserDelay = ({ target })=>{
		const { value } = target;  
		this.setState({ searchedUser: value })
		clearTimeout(this.timer);
		this.timer = setTimeout(() => {
		  this.handleAssignUser(value);
		}, 1000);
	   
	  }
	  

	assignedUserFormat=selectedUser=>{
		let{removeUsers,invitedUsers, item}=this.state
		let { startDate, endDate, name, _id, category}= item
		let event= {
			startDate, endDate, name, eventId: _id,
			category, 
			invitedBy:this.props.user._id
		}

		if(removeUsers.indexOf(selectedUser._id)==-1 || removeUsers.length==0){
		let userId = selectedUser._id
		let organizationId = selectedUser.organizationId 
		let u = {
			// ...selectedUser, 
			...event,
			email:selectedUser.email,
			profilePic: selectedUser.profilePic,
			firstName:selectedUser.firstName,
			lastName:selectedUser.lastName,
			userId, 
			organizationId, 
			dateJoined: new Date(),
			role: eventRoles.filter(e=>e.id == 'MEM')[0] ,
		}

		if( (item.hasOwnProperty('groupId')) || (this.props.groupId!=false)){
			u ={...u, 
				groupId:this.props.groupId,
			}
		}

		this.setState(prevState=>({
			invitedUsers: prevState.invitedUsers.concat(u),
			removeUsers: prevState.removeUsers.concat(selectedUser._id), 
			users: [],
			searchedUser:''
		}))
		let result = invitedUsers.concat(u)
		this.props.setInvitees(result)
		}
	}
  

	getInitials=(user)=>{
		let firstName = user.firstName &&user.firstName.length>0?user.firstName:'N'
		let lastName = user.lastName &&user.lastName.length>0?user.lastName:'N'
		return firstName.charAt(0).toUpperCase()+ lastName.charAt(0).toUpperCase() 
	  }

	  removeUser = user =>{
		let{invitedUsers}=this.state 
		invitedUsers = invitedUsers.filter(e=> e.userId!=user.userId)
		this.setState({ invitedUsers })
		this.props.setInvitees(invitedUsers)
	  }

	  handleAssignUser = value => {
		let{removeUsers}=this.state
		
		if(removeUsers.length==1){
			let res = this.props.invitedUsers.map(e=>e.value)
			removeUsers = [...res, ...res]
		}

		if(value && value.length>0){
		  let payload = {
			name:value,
			removeUsers,
			noLoader: true
		  }
		  axios.post(url.searchUsers, payload).then( (resp,idx) =>{
			let users = resp.data.data
			if(users.length==0){
			  users='No users were found'
			}
			this.setState({users})
		  })
		} else {
		  this.setState({users:[]})
		}
	  
	  }
	 



	  closeGroupModal=()=>{
		  this.setState({isOpen:false})
	  }

	render() {
		//suggest, showArchived, isSentiment, isAnonymous, topicsSelected, selectedFilter, filters, topics, disableSubmit, stories, collapseCompleted, categoryDefinitionPopoverOpen, archievedStories, showRemoveFeedConfirmationModal,
		let { searchedUser, invitedUsers,users, isOpen, item} = this.state;

		return (
		<span> 
			<span className="user_invite_modal_modal_body custom_left_section_menu_fields">
				<div className="floating-label-group grp_invite_user_input_item">
				{invitedUsers.length>0?
				<div className="grp_invite_user_input_invited_users_container">
				{ invitedUsers.map((e,idx)=>{
				return (<span key={e.userId+idx} className="grp_invite_user_input_invited_users">
							{ profilePicValidityCheck(e.profilePic) ?
								<img className="grp_create_search_user_pic" src={e.profilePic}/>
									:
								<span className="spotlightUserInitials" data-letters={this.getInitials(e)}></span>
							}
						{e.firstName} {e.lastName?e.lastName:''}
						<i onClick={()=>this.removeUser(e)}
						className="flaticon-trash"/></span>)
				})}
				</div>
					:
				null}
				<input type="text" id="invitedUsers" className="form-control"
					onChange={this.assignedUserDelay} 
					value={searchedUser}
					autoComplete="off"  placeholder=' '/>
				<label className={invitedUsers.length>0?'floating_label_invite_user':`floating-label`}>{ this.props.mem_label? this.props.mem_label:'Invite members'} </label>
				{Array.isArray(users) && users.length>0?
				<span className="grp_create_search_user_res">
					<div className="divTable">
					<div className="divTableBody">
						
						{users.map( user => {
							return (
								<div className="divTableRow" onClick={()=>this.assignedUserFormat(user)} key={user._id+user.organizationId}>
								<div className="divTableCell">
									{ profilePicValidityCheck(user.profilePic) ?
									<img className="grp_create_search_user_pic" src={user.profilePic}/>
									:
									<span className="spotlightUserInitials" data-letters={this.getInitials(user)}></span>
									}
									{user.firstName} {user.lastName}
								</div>
								</div>
							)
							})}
						
														
						</div>
					</div>   
					</span>                   
					:
					null
					}
				</div> 
		  	</span>					
			  </span>
			)
	}
}

const mapStateToProps = state => {
	return {
    user: state.user.profile,
	};
};


const mapDispatchToProps = dispatch => {
	return {
	  storyMetricsChange: (data) => dispatch(actionCreators.storyMetricsChange(data)),
	}
  }


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InviteUsers));


  
  